/**
 * 編集 (video_edit_projects) の既定名。
 *
 * 以前は「編集{n}」(既存の最大 n + 1) だったが、一覧から見分けにくく、別シナリオでも同じ名前に
 * なるため、作成時刻ベースの「編集 YYYYMMDDHHMMSS」にした。時刻はブラウザのローカル時刻。
 */
export function formatDefaultProjectName(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  const ymd = `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
  const hms = `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  return `編集 ${ymd}${hms}`;
}
